import React from 'react';
import Button from 'devextreme-react/button';
import notify from 'devextreme/ui/notify';
import { saveAs } from 'file-saver';

import BlobUtils from '../../../common/utils/BlobUtils';
import CoreUtils from '../../../common/utils/CoreUtils';
import StringUtils from '../../../common/utils/StringUtils';

import DataItemView from '../../../common/view/DataItemView';
import ModifiedFlag from '../../../common/controls/ModifiedFlag';

export default class CounterpartyLogoView extends DataItemView {
  static displayName = CounterpartyLogoView.name;

  constructor(props) {
    super(props);

    this.bindDataItem(props.counterpartyLogo);

    this.imageFileSelectedHandler = this.onImageFileSelected.bind(this);
    this.imageFileTypes = CounterpartyLogoView.resolveImageFileTypes(this.props.imageMimeTypes);

    this.downloadImageFileHandler = this.onDownloadImageFile.bind(this);
    this.removeImageFileHandler = this.onRemoveImageFile.bind(this);
  }

  componentDidUpdate() {
    this.bindDataItem(this.props.counterpartyLogo);
  }

  render() {
    if (!this.state.isDataBound)
      return (
        <div className="pwx-counterparty-logo-view">
          <div className="pwx-counterparty-logo-container" />
        </div>
      );

    var isImagePresent = StringUtils.isNonEmptyString(this.state.imageDataUri);

    return (
      <div>
        <div className="pwx-counterparty-logo-view">
          <div className="pwx-counterparty-logo-container">
            {
              isImagePresent
                ? (<img className="pwx-counterparty-logo" src={this.state.imageDataUri} alt={this.state.code} />)
                : (<div className="pwx-counterparty-logo-none">(No Image)</div>)
            }
          </div>
          <div className="pwx-counterparty-logo-tile-bar pwx-tile-button-bar">
            <label htmlFor="pwx-image-input"><Button type="normal" icon="upload" hint="Select Image" /></label>
            <input id="pwx-image-input" type="file" accept={this.imageFileTypes} onChange={this.imageFileSelectedHandler} hidden />
            <span className="pwx-button-spacer" />
            <Button type="normal" icon="floppy" hint="Download Image" onClick={this.downloadImageFileHandler} disabled={!isImagePresent} />
            <span className="pwx-button-spacer" />
            <Button type="normal" icon="remove" hint="Remove Image" onClick={this.removeImageFileHandler} disabled={!isImagePresent} />
            <span className="pwx-button-spacer" hidden={!this.state.imageDataUri_isModified} />
            <ModifiedFlag isModifiedProperty={this.state.imageDataUri_isModified} />
          </div>
        </div>
      </div>
    );
  }

  onImageFileSelected(event) {
    var target = event.currentTarget;
    if (CoreUtils.isUndefinedOrNull(target) || CoreUtils.isUndefinedOrNull(target.files) || target.files.length === 0)
      return;

    var file = target.files[0];
    if (CoreUtils.isUndefinedOrNull(file))
      return;

    var imageMimeType = CounterpartyLogoView.resolveMimeTypeFromContentType(file.type);
    if (CoreUtils.isUndefinedOrNull(imageMimeType)) {
      notify(`An invalid image file format was selected (${file.type}).`, 'error', 3000);
      return;
    }

    BlobUtils.convertBlobToTypedDataUri(file, file.type)
      .then(
        imageDataUri => {
          if (this.dataItem !== null)
            this.dataItem.updateProperty('imageDataUri', imageDataUri);
        },
        () => { notify(`An error occurred during image selection.`, 'error', 3000); }
      );
  }

  onDownloadImageFile(event) {
    if (!StringUtils.isNonEmptyString(this.state.imageDataUri))
      return;

    BlobUtils.convertTypedDataUriToBlob(this.state.imageDataUri)
      .then(
        blob => {
          saveAs(blob, CounterpartyLogoView.resolveImageFileName(this.props.counterpartyLabel, blob.type, this.props.imageMimeTypes));
        },
        () => { notify(`An error occurred while attempting to download the image.`, 'error', 3000); }
      );
  }

  onRemoveImageFile(event) {
    if (!StringUtils.isNonEmptyString(this.state.imageDataUri))
      return;

    if (this.dataItem !== null)
      this.dataItem.updateProperty('imageDataUri', '');
  }

  static resolveMimeTypeFromContentType(imageContentType) {
    return imageContentType.replace('image/', '');
  }

  static resolveImageFileName(counterpartyLabel, imageContentType, imageMimeTypes) {
    var fileLabel = counterpartyLabel;
    if (!StringUtils.isNonEmptyString(fileLabel))
      fileLabel = 'Counterparty';

    var fileExtension = CounterpartyLogoView.resolveImageExtension(imageContentType, imageMimeTypes);
    return `${fileLabel}Logo.${fileExtension}`;
  }

  static resolveImageExtension(imageContentType, imageMimeTypes) {
    var imageMimeType = CounterpartyLogoView.resolveMimeTypeFromContentType(imageContentType);
    return imageMimeTypes[imageMimeType];
  }

  static resolveImageFileTypes(imageMimeTypes) {
    return CoreUtils.getObjectPropertyNames(imageMimeTypes)
      .map(imageMimeType => `.${imageMimeTypes[imageMimeType]}`)
      .join(',');
  }
}